import { generateHesBeatStatus } from '@/entities/beat';
import BeatNIcon from './assets/beat-n-icon.svg?react';
import BeatSIcon from './assets/beat-s-icon.svg?react';
import BeatVIcon from './assets/beat-v-icon.svg?react';
import BeatQIcon from './assets/beat-q-icon.svg?react';
import BeatDeleteIcon from './assets/beat-delete-icon.svg?react';
import CloseIcon from './assets/beat-marker-close-icon.svg?react';

/**
 * Builds the N/S/V/Q/delete beat-marker button descriptors for the beat-marker toolbar. Each button's active flag comes from matching beatTypeString, and every button (except the divider) is disabled while a beat is being selected.
 *
 * @param beatTypeString - The current beat type letter ('N' | 'S' | 'V' | 'Q' | 'DEL'), or null.
 * @param isSelectingBeat - Whether a beat is currently being selected, disabling all beat buttons.
 * @param handleChangeBeat - Callback invoked with the HES beat status for the clicked beat type.
 * @returns The beat button descriptor list, including a divider before the delete button.
 */
export const buildBeatButtons = (
  beatTypeString: string | null,
  isSelectingBeat: boolean,
  handleChangeBeat: (beatTypeNumber: number) => void,
) => [
  {
    Icon: BeatNIcon,
    alt: 'Beat icon',
    id: 'beatMarkerN',
    active: beatTypeString === 'N',
    onClick: () => handleChangeBeat(generateHesBeatStatus('N')),
    disable: isSelectingBeat,
    tooltipText: (
      <div className="beat-tooltip">
        Add/Change N<span className="shortkey">N</span>
      </div>
    ),
  },
  {
    Icon: BeatSIcon,
    alt: 'Beat icon',
    id: 'beatMarkerS',
    active: beatTypeString === 'S',
    disable: isSelectingBeat,
    onClick: () => handleChangeBeat(generateHesBeatStatus('S')),
    tooltipText: (
      <div className="beat-tooltip">
        Add/Change S<span className="shortkey">S</span>
      </div>
    ),
  },
  {
    Icon: BeatVIcon,
    alt: 'Beat icon',
    id: 'beatMarkerV',
    active: beatTypeString === 'V',
    disable: isSelectingBeat,
    onClick: () => handleChangeBeat(generateHesBeatStatus('V')),
    tooltipText: (
      <div className="beat-tooltip">
        Add/Change V<span className="shortkey">V</span>
      </div>
    ),
  },
  {
    Icon: BeatQIcon,
    alt: 'Beat icon',
    id: 'beatMarkerQ',
    active: beatTypeString === 'Q',
    disable: isSelectingBeat,
    onClick: () => handleChangeBeat(generateHesBeatStatus('Q')),
    tooltipText: (
      <div className="beat-tooltip">
        Add/Change Q<span className="shortkey">Q</span>
      </div>
    ),
  },
  {
    type: 'divider',
  },
  {
    Icon: BeatDeleteIcon,
    isDelete: true,
    alt: 'Beat icon',
    id: 'beatMarkerDelete',
    active: beatTypeString === 'DEL',
    disable: isSelectingBeat,
    onClick: () => handleChangeBeat(generateHesBeatStatus('DEL')),
    tooltipText: (
      <div className="beat-tooltip">
        Delete beat
        <span className="shortkey">D</span>
      </div>
    ),
  },
];

/**
 * Builds the function-button descriptors (currently just Exit/close) for the beat-marker toolbar.
 *
 * @param onCloseARBeatMode - Callback invoked when the close button is clicked.
 * @returns The function button descriptor list.
 */
export const buildFunctionButtons = (onCloseARBeatMode: () => void) => [
  // {
  //   src: QuestionIcon,
  //   srcOnHover: QuestionActiveIcon,
  //   alt: 'Question icon',
  //   id: 'beatMarkQuestion',
  //   tooltipText: (
  //     <div className="beat-tooltip">
  //       Guide
  //     </div>
  //   ),
  // },
  // {
  //   type: 'divider',
  // },
  {
    Icon: CloseIcon,
    alt: 'Close icon',
    id: 'beatMarkerClose',
    tooltipText: (
      <div className="beat-tooltip">
        Exit
        <span className="shortkey">ESC</span>
      </div>
    ),
    onClick: onCloseARBeatMode,
  },
];
